/**
 * Meldet den Service Worker nur in der ausgelieferten Fassung an (import.meta.env.PROD).
 * In der Entwicklung bliebe ein einmal installierter Vorrat über Vite-Neustarts hinweg
 * bestehen und würde alte Stände ausliefern — genau die Störung, die vermieden werden soll.
 *
 * "/sw.js" liegt an der Wurzel (siehe vite.config.ts, zweiter Rollup-Einstiegspunkt),
 * damit sein scope die ganze Anwendung ("/") umfasst, nicht nur ein Unterverzeichnis.
 */
export function registerSw(): void {
  if (!import.meta.env.PROD) return;
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}
